import { AxiosInstance } from "axios"

/** A yantra model available online: published to the canonical models
 *  bucket and rendered to a page on view.scient.io. */
export interface PublishedModel {
  id: string
  name: string | null
  currency: string | null
  /** Bloomberg-style ticker, null until yantra models carry one */
  instrument: string | null
  /** ISO timestamp of the last build, null if the manifest carries none */
  built_at: string | null
  run_id: string | null
  page_url: string
}

export interface ModelsDirectory {
  models: PublishedModel[]
  /** Prefixes whose manifest could not be read */
  skipped: string[]
}

export interface IViewModelsApi {
  list: () => Promise<ModelsDirectory>
}

const viewModelsApi = (axiosClient: AxiosInstance): IViewModelsApi => ({
  list: async () => {
    const { data } = await axiosClient.get<ModelsDirectory>("/view/models/")
    return data
  },
})

export default viewModelsApi
